module.exports = __webpack_public_path__ + "static/media/Lead in water video REV_1747734747484.4ee44785.docx";